




































import { Component, Vue, Prop, Mixins, Emit } from 'vue-property-decorator'
import Validatable from '@/mixins/Validatable'
import Focusable from '@/mixins/Focusable'
import { defaultFormatter, Formatter } from '@/utils/formatters'
import { BFormTextarea, BSpinner } from 'bootstrap-vue'

@Component({
	components: {
		BFormTextarea,
		BSpinner,
	},
})
export default class TextArea extends Mixins(Vue, Validatable, Focusable) {
	$refs!: {
		focusable: BFormTextarea
	}

	@Prop({ type: String }) readonly value!: string
	@Prop({ type: String }) readonly label!: string
	@Prop({ type: String }) readonly placeholder!: string
	@Prop({ type: Boolean }) readonly required!: boolean
	@Prop({ type: Function }) readonly formatter!: Formatter
	@Prop({
		type: Number,
		default: 4,
	}) readonly rows!: number
	@Prop({
		type: Number,
		default: 8,
	}) readonly maxRows!: number
	@Prop({
		type: Number,
		default: 1000,
		validator: value => {
			return parseInt(value) >= 0 && Number.isInteger(value)
		},
	}) readonly maxLength!: number

	protected readonly defaultRules = [
		(value: string) => !this.required || (value && value.length) ||
			this.$t('This field is required'),
		(value: string) => !this.required || (value && value.length <= this.maxLength) ||
			this.$t('Please enter no more than %s characters', [this.maxLength]),
	]

	get state() {
		if (this.isAsyncValidation || this.catchError) {
			this.catchError = false
			return null
		}
		return this.errorMsg ? false
			: this.value ? true
				: null
	}

	get fgLabel() {
		return this.required
			? `* ${this.label}`
			: this.label
	}

	@Emit('change')
	handleChange(value: string) {
		return value
	}

	handleInput(value: string) {
		this.$emit('input', value)
	}

	handleBlur() {
		this.$refs.focusable.localValue = this.value
	}

	formatterFn(value: string) {
		if (!this.formatter) return defaultFormatter(value)
		return this.formatter(value)
	}
}
